import styled from 'styled-components';

export const PageContainer = styled.div`
	.page-title {
		font-size: 1.2em !important;
		margin-bottom: 0em;
		font-weight: 700;
		@media (max-width: 1450px) {
			font-size: 1em !important;
		}
	}
	.notificationsPageHeader {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin: 2.5rem 0px 2rem 0px;
	}
	.contentPage {
		display: flex;
		margin: 1rem 0px;
		gap: 1rem;

		.notificationsContainer {
			width: 80%;
			border: 1px solid #0000001a;
			border-radius: 1.5rem;
		}
	}
`;

export const NotificationContainer = styled.div<any>`
	font-family: 'Manrope', sans-serif !important ;
	margin-bottom: 0 !important ;
	padding: ${(props) => (props.size === 'mini' ? '1rem' : '2rem')};
	display: flex;
	background-color: #ffffff1a;
	border-bottom: 1px solid #0000001a;
	font-size: 16px;
	/* cursor: pointer; */
	filter: ${(props) => (props.active === 'old' ? 'grayscale(100%) opacity(0.65)' : 'noe')} !important;
	&:last-child {
		border-bottom: 0px;
	}
	.dot {
		min-width: 0.5rem;
		min-height: 0.5rem;
		max-width: 1rem;
		max-height: 0.55rem;
		margin: 0.75rem 0.8rem 0 0;
		background-color: #01abc1;
		/* background-color: ${(props) => (props.active === 'readed' ? '#AFAFAF' : '#01ABC1')}; */
		border-radius: 50%;
		/* border: ${(props) => (props.active === 'readed' ? '#AFAFAF' : '#01ABC1')}; */
	}
	.notiHead {
		display: flex;
		justify-content: space-between;
		margin-bottom: 0.6875rem;
		min-width: 100%;
		.head {
			max-width: 80%;
			font-size: ${(props) => (props.size === 'mini' ? '1.125rem' : '1.25rem')};
			color: #1e1e1e;
			/* color: ${(props) => (props.active === 'readed' ? '#707070' : '#1E1E1E')}; */
			margin: 0px;
			display: flex;
			font-weight: 700;
			align-items: flex-start;
		}
		.time {
			max-width: 20%;
			color: #afafaf;
			/* color: ${(props) => (props.active === 'readed' ? '#dfdfdf' : '#afafaf')}; */
			font-size: 0.9375rem;
			font-size: 1rem;
			margin: 0px;
		}
	}
	.des {
		color: ##707070;
		/* color: ${(props) => (props.active === 'readed' ? '#afafaf' : '#707070')}; */
		max-width: 100%;
		margin: 0px !important ;
		margin-bottom: 0 !important;
		font-size: ${(props) => (props.size === 'mini' ? '0.9375rem' : '1rem')};
		font-weight: 500;
	}
`;

export const SideMenu = styled.div<any>`
	width: 20%;
	@media (max-width: 1520px) {
		width: 23%;
	}
	@media (max-width: 1420px) {
		width: 27%;
	}
	@media (max-width: 1224px) {
		width: 34%;
	}
	.tab {
		display: flex;
		align-items: center;
		padding: 2rem;
		height: 4.5rem;
		gap: 0.5rem;
		background-color: #afafaf1a;
		cursor: pointer;
		/* border-top:0.5px solid #AFAFAF; */
		.icon {
			width: 2rem;
			height: 2rem;
		}
		.tabTitle {
			margin: 0px;
			font-size: 1.125em;
		}
		.dataLenght {
			margin-left: auto;
			font-size: 1rem;
			font-weight: 700;
		}
	}
	.active {
		background-color: #01abc11a;
		border-top: 0.5px solid #afafaf1a;
		color: #01abc1;
	}
`;
